import React from 'react';
import Hello from 'react-reuse/Hello';

/** Custom message */
function ExampleHello() {
    return <Hello message="Nice component guys!" />;
}

export default ExampleHello;



// WEBPACK FOOTER //
// ./src/docs/examples/Hello/ExampleHello.js